export const featuredComments = [
  {
    id: 'c1',
    user: '咸鱼不翻身',
    text: '最绝的是他解释的那两遍，越解释越像在给自己挖坑，笑点直接翻倍，弹幕根本停不下来。',
    likes: 8620,
    tag: '热评第一',
    scene: '直播翻车名场面',
    sceneId: 'live-slip-01',
  },
  {
    id: 'c2',
    user: '快乐星球住户',
    text: '本来只是路过点进来的，结果把这一段循环了七遍。弹幕比内容好看系列，建议直接开弹幕观赏。',
    likes: 5140,
    tag: '高能回复',
    scene: '综艺接梗天花板',
    sceneId: 'variety-catch-meme-02',
  },
  {
    id: 'c3',
    user: '深夜不睡星人',
    text: '“别刷了……这张图发我一份。”管理员这句转折真的太真实了，谁都逃不过集体玩梗。',
    likes: 5930,
    tag: '神评论',
    scene: '群聊高能刷屏大战',
    sceneId: 'group-emoji-war-03',
  },
  {
    id: 'c4',
    user: '弹幕老人',
    text: '这种弹幕最珍贵的是一起完成一件事的感觉。看完会有点莫名的感动，明明大家互不认识。',
    likes: 4720,
    tag: '深度共鸣',
    scene: '弹幕被彻底玩坏',
    sceneId: 'danmaku-overrun-04',
  },
  {
    id: 'c5',
    user: '评论区常驻',
    text: '我承认我是来看评论的。正文划了两秒就到底了，评论看了十分钟，这才是真正的正文。',
    likes: 7210,
    tag: '说到心坎',
    scene: '热评第一永远在整活',
    sceneId: 'top-comment-show-05',
  },
  {
    id: 'c6',
    user: '温柔一点',
    text: '最后他自己转发表情包这段真的加分。能接住玩笑的人，通常都挺可爱的。',
    likes: 2760,
    tag: '热评第一',
    scene: '社死瞬间名场面',
    sceneId: 'social-death-08',
  },
];